import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers } from './listConstants'

const publishedCompaniesListSlice = createSlice({
    name: 'ui/published-companies-list',
    initialState: {
        ...initialState,
        filters: { ...initialState.filters, userType: 'all' },
        pureFilters: { ...initialState.pureFilters, userType: 'all' }
    },
    reducers: {
        ...listReducers,
        onResetFilters(state) {
            state.filters = { userType: 'all' }
            state.pureFilters = { userType: 'all' }
        }
    }
})

export const publishedCompaniesListActions = publishedCompaniesListSlice.actions
export default publishedCompaniesListSlice.reducer
